<style scoped>
.mu-flat-button {
  min-width: 0px;
}
</style>

<template>

<div class="component-wrapper">
  <tag-panel
    v-if="media.custom_tag"
    :mediaId="mediaId"
    :media="media"
    :currentTime="currentTime"
    @onPause="$emit('onPause')"
    @onPlay="$emit('onPlay')"
    @onClickTag="$emit('onClickTag', $event)"
    :tag="tag"
    />
  <span v-else>
    <span v-if="flagFetchedReaction" class="display-flex">
      <mu-tooltip :content="$t('vote.count') + reaction.upvote_count + (reaction.upvote_count > 0 ? $t('vote.swipe_instruction') : $t('vote.times'))" slot="left">
        <v-touch @tap="onClickVote('upvote')" @swipe="onSwipe('upvote')" :enabled="!deleting">
          <mu-button small flat><mu-icon value="thumb_up" left></mu-icon> {{reaction.upvote_user}}</mu-button>
        </v-touch>
      </mu-tooltip>
      <mu-tooltip :content="$t('vote.count') + reaction.question_count + (reaction.question_count > 0 ? $t('vote.swipe_instruction') : $t('vote.times'))" slot="left">
        <v-touch @tap="onClickVote('question')" @swipe="onSwipe('question')" :enabled="!deleting" >
          <mu-button small flat><mu-icon value="sentiment_dissatisfied" left></mu-icon> {{reaction.question_user}}</mu-button>
        </v-touch>
      </mu-tooltip>
      <mu-tooltip :content="$t('vote.count') + reaction.downvote_count + (reaction.downvote_count > 0 ? $t('vote.swipe_instruction') : $t('vote.times'))" slot="left">
        <v-touch @tap="onClickVote('downvote')" @swipe="onSwipe('downvote')" :enabled="!deleting">
          <mu-button small flat><mu-icon value="thumb_down" left></mu-icon> {{reaction.downvote_user}}</mu-button>
        </v-touch>
      </mu-tooltip>
    </span>
  </span>
  <mu-dialog :title="$t('button.delete') + $t('space') + $t('vote.display')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="onCancelDelete"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>
// Library
import axios from "axios";

// Components
import TagPanel from '@/components/Tag/TagPanel.vue'

// Utils
import timeFormatter from '@/utils/timeFormatter.js'

export default {
  name: 'ReactionPanel',
  components: {
    TagPanel
  },
  props: {
    mediaId: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    media: {
      type: Object,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    playlistId: {
      type: String
    },
    tag: {
      type: Object,
      default() {
        return {
          action: '',
          tagId: ''
        }
      }
    },
  },
  data() {
    return {
      // Object
      reaction: "", // Reaction count object
      reactions: [],
      modelReactionDelete: {},

      // Flag
      flagFetchedReaction: false, // Boolean variable for status of fetched reaction
      flagFetchedReactions: false,
      flagDialogCancel: false,
      flagDialogDelete: false,
      deleting: false,
    }
  },
  computed: {
    stringDelete() {
      if(this.modelReactionDelete.hasOwnProperty('type')) {
        if(this.media.type === "youtube" || this.media.type === "video" || this.media.type === "mp4link") {
          return this.$t('prompt.deleteMsg', { name: this.$t('vote.latest') + this.$t('vote.' + this.modelReactionDelete.type) + '(' + this.stringTime(this.modelReactionDelete.timestamp) + ')' });
        } else {
          return this.$t('prompt.deleteMsg', { name: this.$t('vote.latest') + this.$t('vote.' + this.modelReactionDelete.type) });
        }
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.fetchReaction();
  },
  watch: {
    mediaId() {
      this.fetchReaction();
    },
  },
  methods: {
    // Fetch
    fetchReaction() {
      axios.get(this.$store.getters.urlApi + "reaction/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.reaction = response.data.data.reaction
        this.fetchReactions();
        this.flagFetchedReaction = true;
      });
    },
    fetchReactions() {
      axios.get(this.$store.getters.urlApi + "reaction/media/" + this.mediaId + "/list", {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.reactions = response.data.data.reactions
        this.flagFetchedReactions = true;
        if(this.reactions.length <= 0) {
          this.flagDialogCancel = false;
        }
      });
    },

    // String
    stringTime(time) {
      return timeFormatter(time);
    },

    // Event
    onClickVote(type) {
      axios.post(this.$store.getters.urlApi + "reaction/media/" + this.mediaId, {
        'type': type,
        'timestamp': this.currentTime
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.fetchReaction();
      });
    },
    onActionDelete() {
      this.onDeleteVote(this.modelReactionDelete);
    },
    onDeleteVote(item) {
      this.flagDialogDelete = false;
      this.deleting = true;
      axios.delete(this.$store.getters.urlApi + "reaction/" + item._id, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(() => {
        this.fetchReaction();
        this.$toast.success(this.$t('toast.delete'));
        this.deleting = false;
      });
    },
    onCancelDelete() {
      this.modelReactionDelete = "";
      this.flagDialogDelete = false;
    },
    onSwipe(type) {
      this.modelReactionDelete = "";
      this.reactions.forEach(item => {
        if(item.type === type) {
          this.modelReactionDelete = item;
        }
      });
      if(this.modelReactionDelete !== "") {
        this.flagDialogDelete = true;
      } else {
        this.$toast.error(this.$t('vote.no_record'));
      }
    },
  },
}
</script>
